import store from '../store'
export const ANIMATION_DURATION_MS = 60000
export const ANIMATION_DURATION_S = ANIMATION_DURATION_MS / 1000
const startColor = { r: 0, g: 84, b: 223 }
const endColor = { r: 212, g: 227, b: 254 }

export const getSecondsSinceEvent = (serverTime: string) => {
  const eventTime = new Date(serverTime).getTime()
  const now = Date.now()
  const diffSec = (now - eventTime) / 1000
  // Return -1 if older than the entire animation duration or if the time is in the future
  if (diffSec < 0) return -1
  return diffSec
}

export function calculateAnimationProgress(lastMotionAt) {
  const elapsedSeconds = getSecondsSinceEvent(lastMotionAt)
  if (elapsedSeconds < 0) return 1

  const totalDurationSec = ANIMATION_DURATION_MS / 1000
  return Math.min(elapsedSeconds / totalDurationSec, 1)
}

const getAnimationColor = (progressRatio) => {
  const r = Math.round(startColor.r + (endColor.r - startColor.r) * progressRatio)
  const g = Math.round(startColor.g + (endColor.g - startColor.g) * progressRatio)
  const b = Math.round(startColor.b + (endColor.b - startColor.b) * progressRatio)

  return `rgb(${r}, ${g}, ${b})`
}
export const animate = () => {
  if (store.featuresToAnimate.size === 0) {
    store.setAnimationRunning(false)
    return
  }

  const updates: {
    element: HTMLElement | HTMLSpanElement
    style: Partial<CSSStyleDeclaration>
  }[] = []

  for (const feature of store.featuresToAnimate.values()) {
    const progress = calculateAnimationProgress(feature.lastMotionAt)

    if (feature.element instanceof SVGElement) {
      // leaflet polygons
      updates.push({
        element: feature.element,
        style: {
          fill: getAnimationColor(progress),
          fillOpacity: '0.8',
        },
      })
    } else if (feature.element instanceof HTMLSpanElement) {
      //sidebar circles
      updates.push({
        element: feature.element,
        style: {
          backgroundColor: getAnimationColor(progress),
          opacity: '0.8',
        },
      })
    }
  }

  // Apply DOM updates in one go
  requestAnimationFrame(() => {
    updates.forEach((update) => {
      Object.entries(update.style).forEach(([key, value]) => {
        update.element.style[key] = value
      })
    })
  })

  if (store.featuresToAnimate.size > 0) {
    requestAnimationFrame(() => animate())
  } else {
    store.setAnimationRunning(false)
  }
}

export const clearLockdownStoreData = () => {
  store.setIncident(null)
  store.clearFeaturesToAnimate()
  store.setNoMotionSpaces([])
  store.setAnimationRunning(false)
}

export const getTimeAgo = (date: Date, nowMs: number): string => {
  const diffMs = nowMs - date.getTime()
  if (diffMs < 1000) {
    return 'now'
  }

  const seconds = Math.floor(diffMs / 1000)

  if (seconds < 60) {
    return `${seconds}s ago`
  }

  const minutes = Math.floor(seconds / 60)
  const leftoverSeconds = seconds % 60
  if (minutes < 60) {
    return leftoverSeconds === 0 ? `${minutes}m ago` : `${minutes}m ${leftoverSeconds}s ago`
  }

  const hours = Math.floor(minutes / 60)
  const leftoverMinutes = minutes % 60
  return `${hours}h ${leftoverMinutes}m ${leftoverSeconds}s ago`
}
